<div class="d-flex vh-100 bg-black">
    <!--login-form-->
    <main class="login-form-container w-100 d-flex flex-column justify-content-center p-4 p-lg-5 shadow-lg z-1 position-relative"
        style="max-width: 420px;" aria-label="Authentication portal">
        <div class="w-100">
            <!--logo-title-->
            <div class="d-flex flex-column align-items-center justify-content-center mb-5">
                <img src="images/logo_1_2.png" alt="Rival Forge Logo" class="mb-3" style="height: 5rem;" title="Rival Forge Logo">
                <h1 class="display-6 fw-bold ms-3" style="letter-spacing: .1em;">RIVAL<span
                        class="text-danger">FORGE</span></h1>
            </div>
            <!--./logo-title-->

            @switch (viewMode()) {
            @case ('login') {
            <app-login-form (changeView)="setView($event)" />
            }
            @case ('recover') {
            <app-recover-form (changeView)="setView($event)" (recoveryRequested)="recoveryEmail.set($event)"></app-recover-form>
            }
            @case ('enter-code') {
            <app-enter-code-form [recoveryEmail]="recoveryEmail()" (changeView)="setView($event)"
                (codeVerified)="handleCodeVerified($event)"></app-enter-code-form>
            }
            @case ('reset-password') {
            <app-reset-password-form [recoveryUsername]="recoveryEmail()" [resetToken]="resetToken()" (changeView)="setView($event)"
                (passwordReset)="handlePasswordReset()"></app-reset-password-form>
            }
            }
        </div>
        <div class="position-absolute bottom-0 start-50 translate-middle-x pb-3 login-version small" aria-label="Application version">
            v{{ version }}
        </div>
    </main>
    <!--./login-form-->

    <!-- Right Side: Video Section -->
    <section class="d-none d-lg-flex flex-grow-1 position-relative bg-cover bg-center" aria-label="Featured Season Promo">

        <video autoplay [muted]="isMuted()" playsinline aria-hidden="true" tabindex="-1"
            class="position-absolute top-0 start-0 end-0 bottom-0 h-100 w-100" style="object-fit: cover;" preload="auto"
            #bgVideo>
        </video>


        <div class="position-absolute top-0 start-0 bottom-0 end-0 bg-black opacity-50" aria-hidden="true"></div>
        <div
            class="position-relative w-100 z-1 d-flex flex-column align-items-center justify-content-center text-white p-5">
            <h2 class="display-2 fw-bolder text-uppercase mb-4 text-shadow" style="letter-spacing: .2em;">New Season
                Live</h2>
            <p class="fs-5 text-center text-white-75" style="max-width: 500px;">Experience the latest chapter. New
                agents, new maps, and a new meta await. Dive in now.</p>
        </div>
        <div class="position-absolute bottom-0 end-0 m-4 d-flex gap-2 z-3">
            <button (click)="togglePlay()"
                class="btn btn-dark rounded-circle d-flex align-items-center justify-content-center"
                style="width: 3.5rem; height: 3.5rem; background-color: rgba(0,0,0,0.6);"
                [attr.aria-label]="isPlaying() ? 'Pause background video' : 'Play background video'"
                [title]="isPlaying() ? 'Pause video' : 'Play video'">
                @if(isPlaying()) {
                <i class="bi bi-pause-fill fs-4" aria-hidden="true"></i>
                } @else {
                <i class="bi bi-play-fill fs-4" aria-hidden="true"></i>
                }
            </button>
            <button (click)="toggleMute()"
                class="btn btn-dark rounded-circle d-flex align-items-center justify-content-center"
                style="width: 3.5rem; height: 3.5rem; background-color: rgba(0,0,0,0.6);"
                [attr.aria-label]="isMuted() ? 'Unmute video audio' : 'Mute video audio'"
                [title]="isMuted() ? 'Unmute audio' : 'Mute audio'">
                @if(isMuted()) {
                <i class="bi bi-volume-mute-fill fs-4" aria-hidden="true"></i>
                } @else {
                <i class="bi bi-volume-up-fill fs-4" aria-hidden="true"></i>
                }
            </button>
        </div>
    </section>
</div>

<app-register-modal />